<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="props.size" :background="props.background" viewBox="0 0 17 16">
    <path
      d="M0.844238 1.67575C0.844238 1.18901 1.23882 0.794434 1.72556 0.794434H15.8267C16.3134 0.794434 16.708 1.18901 16.708 1.67575V1.67575C16.708 2.16249 16.3134 2.55707 15.8267 2.55707H1.72556C1.23882 2.55707 0.844238 2.16249 0.844238 1.67575V1.67575ZM4.36952 14.8955C4.36952 14.4088 4.7641 14.0142 5.25083 14.0142H15.8267C16.3134 14.0142 16.708 14.4088 16.708 14.8955V14.8955C16.708 15.3823 16.3134 15.7769 15.8267 15.7769H5.25083C4.7641 15.7769 4.36952 15.3823 4.36952 14.8955V14.8955ZM0.844238 10.4889C0.844238 10.0022 1.23882 9.60763 1.72556 9.60763H15.8267C16.3134 9.60763 16.708 10.0022 16.708 10.4889V10.4889C16.708 10.9757 16.3134 11.3703 15.8267 11.3703H1.72556C1.23882 11.3703 0.844238 10.9757 0.844238 10.4889V10.4889ZM4.36952 6.08235C4.36952 5.59561 4.7641 5.20103 5.25083 5.20103H15.8267C16.3134 5.20103 16.708 5.59561 16.708 6.08235V6.08235C16.708 6.56909 16.3134 6.96367 15.8267 6.96367H5.25083C4.7641 6.96367 4.36952 6.56909 4.36952 6.08235V6.08235Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
